// Unfortunately eslint takes into the account amount of validation ifs, that's why this check is disabled for below.
// eslint-disable-next-line complexity
export const denormalize = (layout, transform = x => x) => {
  if (typeof layout !== 'object') {
    throw Error('Invalid 1st input argument - expected an object');
  }
  const { root, components } = layout;
  if (!root) {
    throw Error('Invalid 1st input argument - the `root` property is missing');
  }
  if (!components) {
    throw Error(
      'Invalid 1st input argument - the `components` property is missing'
    );
  }
  if (!components[root]) {
    throw Error('Invalid input - provided `root` component cannot be found');
  }

  const stack1 = [root];
  const stack2 = [];
  const stack3 = [];
  /*
  The order in which algorithm traverse through the exemplary tree (stack1) and collects
  nodes for further denormalization (stack2).

  Tree   |Order
  a       (1)
  |_ b    (5)
    |_ c  (7)
    |_ d  (6)
  |_ e    (2)
    |_ f  (4)
    |_ g  (3)
   */
  while (stack1.length > 0) {
    const id = stack1.pop();
    if (!components[id]) {
      throw Error(
        `Invalid input - referenced "${id}" component cannot be found`
      );
    }
    if (!components[id].type) {
      throw Error(
        `Invalid input - "${id}" component does not provide required \`type\` property`
      );
    }
    const children = components[id].children || [];
    stack1.push(...children);
    stack2.push(id);
  }
  /*
  The order in which algorithm traverse the exemplary tree (stack2) and builds up denormalized tree (stack3).

  Tree   |Order |What happens                            |stack3
  a       (7) -> a has 2 children (b, e)                  [a(b(c, d), e(f, g))]
                  so pop 2 elements from stack3
                  and nest inside of a, push a to stack3
  |_ b    (3) -> b has 2 children (c, d)                  [b(c,d)]
                  so pop 2 elements from stack3
                  and nest inside of b, push b to stack3
    |_ c  (1) -> c has 0 children, push to stack3         [c]
    |_ d  (2) -> d has 0 children, push to stack3         [c, d]
  |_ e    (6) -> e has 2 children (f, g)                  [b(c,d), e(f, g)]
                  so pop 2 elements from stack3
                  and nest inside of e, push e to stack3
    |_ f  (4) -> f has 0 children, push to stack3         [b(c,d), f]
    |_ g  (5) -> g has 0 children, push to stack3         [b(c,d), f, g]
   */
  while (stack2.length > 0) {
    const id = stack2.pop();
    const { type, properties, children = [] } = components[id];
    // Pop n nodes from stack.
    const collected = stack3.splice(
      stack3.length - children.length,
      children.length
    );
    stack3.push(
      transform({
        id,
        type,
        properties,
        children: collected,
      })
    );
  }
  return stack3.pop();
};
